import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import DashLayout from '../../components/DashLayout';
import { useAuth } from '../../context/AuthContext';

const nav = [
  { to: '/agent',         icon: '💬', label: 'Live Chats' },
  { to: '/agent/leads',   icon: '👥', label: 'Leads' },
  { to: '/agent/crm',     icon: '📋', label: 'CRM' },
  { to: '/agent/profile', icon: '👤', label: 'My Profile' },
];

export default function AgentProfile() {
  const { user } = useAuth();
  const [pwForm, setPwForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [loading, setLoading] = useState(false);

  const changePassword = async () => {
    if (pwForm.new_password !== pwForm.confirm_password) return toast.error('Passwords do not match');
    if (pwForm.new_password.length < 8) return toast.error('Password must be at least 8 characters');
    setLoading(true);
    try {
      await axios.post('/api/auth/change-password', { current_password: pwForm.current_password, new_password: pwForm.new_password });
      toast.success('Password changed successfully!');
      setPwForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); } finally { setLoading(false); }
  };

  return (
    <DashLayout navItems={nav} role={user?.role === 'main_agent' ? 'Main Agent' : 'Agent'}>
      <div style={{ padding: 28, maxWidth: 600 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>My Profile</h1>
        <p style={{ color: '#555', fontSize: 13, marginBottom: 28 }}>View your account details and change your password</p>

        {/* Profile info */}
        <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, padding: 20, marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
            <div style={{ width: 60, height: 60, borderRadius: '50%', background: 'rgba(0,213,91,0.15)', border: '2px solid #00d55b', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, fontWeight: 700, color: '#00d55b' }}>
              {user?.name?.[0]?.toUpperCase() || '?'}
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: 600 }}>{user?.name}</div>
              <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>{user?.role === 'main_agent' ? 'Main Agent' : 'Agent'} · {user?.company_name}</div>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {[['Email', user?.email], ['Role', user?.role === 'main_agent' ? 'Main Agent' : 'Agent'], ['Business', user?.company_name], ['Status', 'Active']].map(([k, v]) => (
              <div key={k} style={{ background: '#0d0d0d', borderRadius: 8, padding: '10px 14px' }}>
                <div style={{ fontSize: 11, color: '#555', marginBottom: 3 }}>{k}</div>
                <div style={{ fontSize: 13, color: '#fff' }}>{v}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Change password */}
        <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, padding: 20 }}>
          <h3 style={{ fontSize: 14, fontWeight: 600, marginBottom: 20 }}>Change Password</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div><label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>Current password</label><input type="password" value={pwForm.current_password} onChange={e => setPwForm(f => ({ ...f, current_password: e.target.value }))} placeholder="Your current password" /></div>
            <div><label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>New password</label><input type="password" value={pwForm.new_password} onChange={e => setPwForm(f => ({ ...f, new_password: e.target.value }))} placeholder="Min 8 characters" /></div>
            <div><label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>Confirm new password</label><input type="password" value={pwForm.confirm_password} onChange={e => setPwForm(f => ({ ...f, confirm_password: e.target.value }))} placeholder="Repeat new password" /></div>
            <button onClick={changePassword} disabled={loading} style={{ padding: '11px', background: '#00d55b', color: '#000', borderRadius: 8, fontWeight: 700, fontSize: 14, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Changing...' : 'Change Password'}
            </button>
          </div>
          <div style={{ marginTop: 16, padding: '12px 14px', background: '#0d0d0d', borderRadius: 8 }}>
            <p style={{ color: '#555', fontSize: 12, lineHeight: 1.6 }}>Forgot your current password? Click "Forgot password" on the login page to notify the admin for a manual reset.</p>
          </div>
        </div>
      </div>
    </DashLayout>
  );
}